
import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import SettingsFastBalancesPage, { getDefaultPageData } from "components/pages/SettingsFastBalancesPage";
import Classes from "model";
import Util from "classes/Util";
import { useEffect } from "react";

export default function CaptureFastBalancesDeviceAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const mobileDevice = BCMSDefaultModel.mobileDevice();
    mobileDevice.name = "George's Phone";
    mobileDevice.isEnrolled = true;
    mobileDevice.recentlyEnrolled = false;

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "mobileDevice" ], mobileDevice)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <span className="success-007"><SettingsFastBalancesPage data={ data } /></span>;
}